import { PaymentOption } from "common/types/checkout";

export const defaultPaymentNote = `After clicking "Pay Now", further instructions will be given to you upon completing your order.`;
export const paymongoNote = `After clicking "Pay Now", you will be redirected to Secure Payments via Paymongo to complete your purchase securely.`;

export const kidneyNote = `DISCLAIMER!! For entertainment purposes only. Stay healthy mga bossing!!!`;

export const buyNowPayLaterMsg = `Hello, PC Worth, I'm interested in your Buy Now, Pay Later program and I would like to know more information about the installment plans available. Thank you!`;

export const paymentOptions: PaymentOption[] = [
  // {
  //   id: 999,
  //   label: "Kidney(s)",
  //   value: "Kidney",
  //   img_thumbnail: "/assets/images/payment-card/kidney.png",
  //   note: kidneyNote,
  // },
  // {
  //   id: 1,
  //   label: "Direct GCash Transfer",
  //   value: "Gcash",
  //   img_thumbnail: "/assets/images/payment-card/gcash.png",
  //   note: defaultPaymentNote,
  // },
  // {
  //   id: 2,
  //   label: "Direct Bank Transfer (BDO)",
  //   value: "Online Bank Transfer",
  //   img_thumbnail: "/assets/images/payment-card/bdo.png",
  //   imgHeight: 12,
  //   note: defaultPaymentNote,
  // },
  {
    id: 3,
    label: "Credit/Debit Card",
    subLabel: "via Paymongo",
    value: "Paymongo",
    img_thumbnails: [
      "/assets/images/payment-card/paymongo-options.png",
      "/assets/images/payment-card/gcash.png",
    ],
    imgHeight: 15,
    note: paymongoNote,
  },
  // {
  //   id: 4,
  //   label: "Secure Payments (via Paymongo)",
  //   value: "Paymongo-REMOVEMELATERFORAPI", // REMOVE -REMOVEMELATERFORAPI BEFORE SENDING TO API // THIS TEMP ONLY
  //   img_thumbnail: "/assets/images/payment-card/paymongo-cc.png",
  //   imgHeight: 12,
  //   note: paymongoNote,
  // },
  // {
  //   id: 5,
  //   label: "Cash on Delivery",
  //   value: "COD",
  //   note: defaultPaymentNote,
  // },
];
